import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import Dashboard from "./components/Dashboard";
import Login from "./components/Login";
import NuevoCliente from "./components/NuevoCliente";
import CancelacionDocumentos from "./components/CancelacionDocumentos";
import CierreDocumentos from "./components/CierreDocumentos";
import UploadEscuelas from "./components/UploadEscuelas";
import OrdenesVenta from "./components/OrdenesVenta";
import Remisiones from "./components/Remisiones";
import ActualizarOrders from "./components/ActualizarOrders";
import OrdersUpdateLines from "./components/ActualizarItems";
import Sudameris from "./components/PagoSudameris";
import Atlas from "./components/PagoAtlas";
import AsistentePagos from "./components/AsistentePagos";
import OrdersServices from "./components/OrdenesServicios";
import Planificacion from "./components/Planificacion";
import Ejecucion from "./components/Ejecucion";
import EjecucionEscuelas from "./components/EjecucionEscuela";
import PrivateRoute from "./components/PrivateRoute";
import ActualizarEntregas from "./components/ActualizarEntregas";
import Consolidados from "./components/Consolidados";
import ConsolidadosGeneral from "./components/ConsolidadoGeneral";
import AsignacionRutas from "./components/AsignacionRutas";
import OrdenesCompra from "./components/OrdenesCompra";
import TableroOrdenesCompra from "./components/OrdenesComprasInformes";
import SolicitudesTraslado from "./components/SolicitudesTraslados";
import Preparacion from "./components/Preparacion";
import AsignacionCamiones from "./components/AsigancionCamiones";
import Asignaciones from "./components/Asignaciones";
import DescargaRemisiones from "./components/DescargarRemisiones";
import Choferes from "./components/Choferes";
import RuteoPendiente from "./components/RuteoPendiente";
import RuteoCamiones from "./components/RuteoCamiones";
import Devoluciones from "./components/Devoluciones";
import Picking from "./components/Picking";
import StockAlmacen from "./components/StockAlmacen";

const ListaClientes = () => <h2>Lista de Clientes</h2>;
const Documentos = () => <h2>Documentos de Marketing</h2>;

const App = () => {
    const [loggedIn, setLoggedIn] = useState(false);
    const [checkingAuth, setCheckingAuth] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem("sapToken");
        if (token) {
            setLoggedIn(true);
        }
        setCheckingAuth(false);
    }, []);

    // Control de expiración automática de sesión
    useEffect(() => {
        const interval = setInterval(() => {
            const userData = JSON.parse(localStorage.getItem("sapUser"));
            if (userData && userData.ExpiresAt) {
                const now = new Date();
                const expiresAt = new Date(userData.ExpiresAt);
                if (now >= expiresAt) {
                    console.warn("Sesión expirada. Cerrando sesión automáticamente...");
                    handleLogout(); // Llama a tu función para cerrar sesión
                    const base = process.env.PUBLIC_URL || "";
                    window.location.href = `${base}/login`; // Redirige al login respetando subruta
                }
            }
        }, 60000); // cada 1 minuto

        return () => clearInterval(interval);
    }, []);

    const handleLogout = () => {
        localStorage.removeItem("sapToken");
        setLoggedIn(false);
    };

    if (checkingAuth) return <div className="text-center mt-5">Verificando sesión...</div>;

    const basename = process.env.PUBLIC_URL || "/";

    return (
        <Router basename={basename}>
            {loggedIn && <Navbar handleLogout={handleLogout} />}
            <div className="container mt-4">
                <Routes>
                    <Route path="/" element={<Navigate to={loggedIn ? "/dashboard" : "/login"} replace />} />
                    <Route path="/login" element={loggedIn ? <Navigate to="/dashboard" replace /> : <Login setLoggedIn={setLoggedIn} />} />

                    {/* Rutas protegidas con PrivateRoute */}
                    <Route path="/dashboard" element={<PrivateRoute loggedIn={loggedIn}><Dashboard /></PrivateRoute>} />
                    <Route path="/clientes/nuevo" element={<PrivateRoute loggedIn={loggedIn}><NuevoCliente /></PrivateRoute>} />
                    <Route path="/clientes/lista" element={<PrivateRoute loggedIn={loggedIn}><ListaClientes /></PrivateRoute>} />
                    <Route path="/documentos" element={<PrivateRoute loggedIn={loggedIn}><Documentos /></PrivateRoute>} />
                    <Route path="/ventas/cancelacion-documentos" element={<PrivateRoute loggedIn={loggedIn}><CancelacionDocumentos /></PrivateRoute>} />
                    <Route path="/ventas/cierre-documentos" element={<PrivateRoute loggedIn={loggedIn}><CierreDocumentos /></PrivateRoute>} />
                    <Route path="/clientes/cargar-escuelas" element={<PrivateRoute loggedIn={loggedIn}><UploadEscuelas /></PrivateRoute>} />
                    <Route path="/ventas/actualizacion-precios" element={<PrivateRoute loggedIn={loggedIn}><OrdenesVenta /></PrivateRoute>} />
                    <Route path="/ventas/remisiones" element={<PrivateRoute loggedIn={loggedIn}><Remisiones /></PrivateRoute>} />
                    <Route path="/ventas/pedidos/asignacion-logistica" element={<PrivateRoute loggedIn={loggedIn}><ActualizarOrders /></PrivateRoute>} />
                    <Route path="/ventas/remisiones/asignacion-logistica" element={<PrivateRoute loggedIn={loggedIn}><ActualizarEntregas /></PrivateRoute>} />
                    <Route path="/ventas/pedidos/actualizar-lineas" element={<PrivateRoute loggedIn={loggedIn}><OrdersUpdateLines /></PrivateRoute>} />
                    <Route path="/bancos/pagos/sudameris" element={<PrivateRoute loggedIn={loggedIn}><Sudameris /></PrivateRoute>} />
                    <Route path="/bancos/pagos/atlas" element={<PrivateRoute loggedIn={loggedIn}><Atlas /></PrivateRoute>} />
                    <Route path="/bancos/asistente-pagos" element={<PrivateRoute loggedIn={loggedIn}><AsistentePagos /></PrivateRoute>} />
                    <Route path="/clientes/cargar-ordenes-servicios" element={<PrivateRoute loggedIn={loggedIn}><OrdersServices /></PrivateRoute>} />
                    <Route path="/compras/planificacion" element={<PrivateRoute loggedIn={loggedIn}><Planificacion /></PrivateRoute>} />
                    <Route path="/compras/ejecucion/v2" element={<PrivateRoute loggedIn={loggedIn}><Ejecucion /></PrivateRoute>} />
                    <Route path="/compras/ejecucion/escuelas" element={<PrivateRoute loggedIn={loggedIn}><EjecucionEscuelas /></PrivateRoute>} />
                    <Route path="/inventario/consolidado" element={<PrivateRoute loggedIn={loggedIn}><Consolidados /></PrivateRoute>} />
                    <Route path="/inventario/preparacion" element={<PrivateRoute loggedIn={loggedIn}><Preparacion /></PrivateRoute>} />
                    <Route path="/inventario/picking" element={<PrivateRoute loggedIn={loggedIn}><Picking /></PrivateRoute>} />
                    <Route path="/inventario/stock" element={<PrivateRoute loggedIn={loggedIn}><StockAlmacen /></PrivateRoute>} />
                    <Route path="/inventario/devoluciones" element={<PrivateRoute loggedIn={loggedIn}><Devoluciones /></PrivateRoute>} />
                    <Route path="/inventario/asignacioncamiones" element={<PrivateRoute loggedIn={loggedIn}><AsignacionCamiones /></PrivateRoute>} />
                    <Route path="/inventario/consolidado/general" element={<PrivateRoute loggedIn={loggedIn}><ConsolidadosGeneral /></PrivateRoute>} />
                    <Route path="/inventario/ordenescompra" element={<PrivateRoute loggedIn={loggedIn}><OrdenesCompra /></PrivateRoute>} />
                    <Route path="/inventario/tablero/ordenescompra" element={<PrivateRoute loggedIn={loggedIn}><TableroOrdenesCompra /></PrivateRoute>} />
                    <Route path="/inventario/solicitudestraslados" element={<PrivateRoute loggedIn={loggedIn}><SolicitudesTraslado /></PrivateRoute>} />
                    <Route path="/logistica/asigancionrutas" element={<PrivateRoute loggedIn={loggedIn}><AsignacionRutas /></PrivateRoute>} />
                    <Route path="/logistica/asignaciones" element={<PrivateRoute loggedIn={loggedIn}><Asignaciones /></PrivateRoute>} />
                    <Route path="/logistica/choferes" element={<PrivateRoute loggedIn={loggedIn}><Choferes /></PrivateRoute>} />
                    <Route path="/logistica/descargas/remisiones" element={<PrivateRoute loggedIn={loggedIn}><DescargaRemisiones /></PrivateRoute>} />
                    <Route path="/logistica/ruteo-pendiente" element={<PrivateRoute loggedIn={loggedIn}><RuteoPendiente /></PrivateRoute>} />
                    <Route path="/logistica/ruteo-camiones" element={<PrivateRoute loggedIn={loggedIn}><RuteoCamiones /></PrivateRoute>} />

                    {/* Catch-all: si no hay match, redirige */}
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </div>
        </Router>
    );
};

export default App;
